import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

const HU_MAP: Record<string, string> = {
    á: 'a', é: 'e', í: 'i', ó: 'o', ö: 'o', ő: 'o', ú: 'u', ü: 'u', ű: 'u',
    Á: 'a', É: 'e', Í: 'i', Ó: 'o', Ö: 'o', Ő: 'o', Ú: 'u', Ü: 'u', Ű: 'u',
};

/**
 * Bármilyen szövegből érvényes slug-ot képez.
 * Szabályok: csak [a-z0-9-], ékezetek → ASCII, szóközök/egyéb → '-',
 * dupla kötőjel összevonva, vezető/záró kötőjel levágva.
 */
export function toSlug(value: string): string {
    return value
        .replace(/[áéíóöőúüűÁÉÍÓÖŐÚÜŰ]/g, (c) => HU_MAP[c] ?? c)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
